import MainCatalogsEditorBase from '../MainCatalogsEditorBase';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './FileCategoryEditor.html?raw';
import Edit from '../../../moreCore/UI/Edit/Edit';
import NumberInput from '../../../moreCore/UI/NumberInput/NumberInput';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
import { MainCatalogTypes, MainCatalogs_Classes } from "../../_loadingHelpers/MainCatalogTypes";

class FileCategoryEditor extends compose(MainCatalogsEditorBase) {
    templateString: any = template;

    fc_Input_Code: MdsLax<InstanceType<typeof Edit>>;
    fc_Input_Description: MdsLax<InstanceType<typeof Edit>>;
    fc_Input_Note: MdsLax<InstanceType<typeof Edit>>;
    fc_Input_TextColor: HTMLInputElement;
    fc_Input_BackgroundColor: HTMLInputElement;
    fc_Input_Order: MdsLax<InstanceType<typeof NumberInput>>;
    fc_Checkbox_Active: MdsLax<InstanceType<typeof CheckBox>>;
    fc_Input_VtFileClass: MdsLax<InstanceType<typeof SearchSelect>>;

    formData: MainCatalogTypes.FileCategory_SaveData = {
        ID: "",
        is_new_status: null,
        code: "",
        description: "",
        note: "",
        order: null,
        coloration: null,
        is_active: null,
        vtFileClass_id: ""
    };

    prepareFormData(data?: MainCatalogTypes.FileCategory_LoadData): void {

        let vtFileClassId: string = null;

        if (data) {

            this.fc_Input_Code.setValue(data.code, true);
            this.fc_Input_Description.setValue(data.description, true);
            this.fc_Input_Note.setValue(data.note, true);

            this.fc_Input_TextColor.value = data.coloration.TextColor.Hex;
            this.fc_Input_BackgroundColor.value = data.coloration.BackColor.Hex;

            this.fc_Input_Order.setValue(data.order, true);

            this.fc_Checkbox_Active.setValue(data.is_active, true);

            this.fc_Input_VtFileClass.loadListValues(data.ref_VtFileClass?.ID, true);
            vtFileClassId = data.ref_VtFileClass?.ID

            this.formData.ID = data.ID;
            this.formData.is_new_status = false;
        } else {

            this.fc_Input_Code.setValue("", true);
            this.fc_Input_Description.setValue("", true);
            this.fc_Input_Note.setValue("", true);

            this.fc_Input_BackgroundColor.value = "#ffffff";
            this.fc_Input_TextColor.value = "#000000";

            this.fc_Input_Order.setValue(null, true);

            this.fc_Checkbox_Active.setValue(true, true);

            this.fc_Input_VtFileClass.loadListValues();

            this.formData.ID = "";
            this.formData.is_new_status = true;
        }

        this.serializeFormData(vtFileClassId);
        this.originalData = JSON.stringify(this.formData);
        console.debug("ORIGINAL", this.originalData);
        this.StandbyStop();

        this.checkDirty();
    }

    serializeFormData(vtFileClassId?: string): void {

        this.formData.code = this.fc_Input_Code.getValue();
        this.formData.description = this.fc_Input_Description.getValue();
        this.formData.note = this.fc_Input_Note.getValue();

        this.formData.order = this.fc_Input_Order.getValue();

        this.formData.is_active = this.fc_Checkbox_Active.getValue();

        vtFileClassId ? this.formData.vtFileClass_id = vtFileClassId : this.formData.vtFileClass_id = this.fc_Input_VtFileClass.getValue();

        let coloration: MainCatalogTypes.PIT_Coloration = {
            TextColor: null,
            BackColor: null
        };
        let textColor: MainCatalogTypes.PIT_Color = {
            Hex: "",
            Red: 0,
            Green: 0,
            Blue: 0
        };
        let backColor: MainCatalogTypes.PIT_Color = {
            Hex: "",
            Red: 0,
            Green: 0,
            Blue: 0
        };
        let textHex = this.fc_Input_TextColor.value;
        let backHex = this.fc_Input_BackgroundColor.value;

        textColor.Hex = textHex;
        textColor.Red = parseInt(textHex.slice(1, 3), 16);
        textColor.Green = parseInt(textHex.slice(3, 5), 16);
        textColor.Blue = parseInt(textHex.slice(5, 7), 16);

        backColor.Hex = backHex;
        backColor.Red = parseInt(backHex.slice(1, 3), 16);
        backColor.Green = parseInt(backHex.slice(3, 5), 16);
        backColor.Blue = parseInt(backHex.slice(5, 7), 16);

        coloration.TextColor = textColor;
        coloration.BackColor = backColor;

        this.formData.coloration = coloration;

        console.debug("SERIALIZED DATA", this.formData);
    }

    _onChangeServiceCategoryInputData(): void {

        this.serializeFormData();
        this.checkDirty();
    }

    _onChangeInputNoteData(): void {

        this.fixNewLineInMultilineEdit(this.fc_Input_Note);

        this.serializeFormData();
        this.checkDirty();
    }

    isValid(): boolean {

        let b: boolean = true;

        if (!this.formData.code) b = false;

        if (!this.formData.description) b = false;

        if (!this.formData.vtFileClass_id) {

            //this.indicateErrorOnInput(this.fc_Input_VtFileClass.outerInput);
            b = false;
        }

        return b;
    }

    //BASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.entityClass = MainCatalogs_Classes.FileCategory;

        this.fc_Input_Code.setMaxLength(15);
        this.fc_Input_Description.setMaxLength(255);
        this.fc_Input_Note.setMaxLength(2000);
        this.fc_Input_Note.setValidationEnabled(false);

        this.fc_Input_VtFileClass.setOuterPlaceholder("MainCatalogsEditor_Placeholder_VtFileClass");
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

mdsLazyProto(FileCategoryEditor.prototype, {
  fc_Input_Code: () => (new Edit()),
  fc_Input_Description: () => (new Edit()),
  fc_Input_Note: () => (new Edit()),
  fc_Input_Order: () => (new NumberInput()),
  fc_Checkbox_Active: () => (new CheckBox()),
  fc_Input_VtFileClass: () => (new SearchSelect()),
});
export default mdsWidget(FileCategoryEditor);